"use strict";
/* tslint:disable no-bitwise radix variable-name */
Object.defineProperty(exports, "__esModule", { value: true });
function random(min, max) {
    return Math.floor(max - Math.random() * (max - min));
}
var XORCipher = {
    encode: function (key, data) {
        data = xor_encrypt(key, data);
        return b64_encode(data);
    }
};
var b64_table = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function keyCharAt(key, i) {
    return key.charCodeAt(Math.floor(i % key.length));
}
function xor_encrypt(key, data) {
    return data.split("").map(function (c, i) {
        return c.charCodeAt(0) ^ keyCharAt(key, i);
    });
}
function generatePassword(length) {
    var charset = "abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    var retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
}
function b64_encode(data) {
    var o1, o2, o3, h1, h2, h3, h4, bits, r, i = 0, enc = "";
    if (!data) {
        return data;
    }
    do {
        o1 = data[i++];
        o2 = data[i++];
        o3 = data[i++];
        bits = o1 << 16 | o2 << 8 | o3;
        h1 = bits >> 18 & 0x3f;
        h2 = bits >> 12 & 0x3f;
        h3 = bits >> 6 & 0x3f;
        h4 = bits & 0x3f;
        enc += b64_table.charAt(h1) + b64_table.charAt(h2) + b64_table.charAt(h3) + b64_table.charAt(h4);
    } while (i < data.length);
    r = data.length % 3;
    return (r ? enc.slice(0, r - 3) : enc) + "===".slice(r || 3);
}
exports.default = (function (json) {
    var keyLength = random(12, 20), key = generatePassword(keyLength), encoded = XORCipher.encode(key, JSON.stringify(json)), prefix = generatePassword(3);
    return "" + prefix + keyLength + key + encoded;
});
